<template>
    <div>
        <el-dialog :close-on-click-modal="clickClose" :model-value="dialogTableData.state" :destroy-on-close="true" draggable @close="close"
                   :width="width?width:700" :top="top" :align-center="center">
            <template #header>
                <div class="title">
                    {{dialogTableData.title}}
                </div>
            </template>
            <el-scrollbar>
                <tables :tableData="dialogTableData.tableData" tableKey="dialogTable"></tables>
            </el-scrollbar>
            <template #footer >
                <el-button @click="dialogTableData.state = false">关 闭</el-button>
                <el-button @click="(e)=>{if(dialogTableData.onSubmit)dialogTableData.onSubmit(e)}"
                           v-if="dialogTableData.onSubmit" color="#ff6633" type="primary">保 存</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import tables from '@/components/tables.vue'
    export default {
        name: "dialogTable", //弹出表格窗口组件
        components:{
            tables,
        },
        props: {
            //点击其他地方是否可以关闭页面
            clickClose:{
                type: Boolean,
                default: false
            },
            //窗口宽度
            width:{
                type: null,
                default: null
            },
            //窗口距顶部距离
            top:{
                type: null,
                default: null
            },
            //窗口是否上下左右居中
            center:{
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
               /* 窗口table数据说明
               dialogTableData: {
                    //窗口显示状态
                    state: true,
                    //窗口标题
                    title: '请选择用户',
                    //窗口table数据,具体看table说明
                    tableData:{}
                },*/
                dialogTableData:{},
            }
        },
        methods:{

            /**
             * 关闭回调
             */
            close(){
                this.dialogTableData.state = false
            },

            /**
             * 初始化数据
             */
            initData(e){
                this.dialogTableData = e;
            },
        }
    }
</script>

<style scoped>
    .title{
        font-weight: 800;
        font-size: 17px;
    }
    :deep(.el-dialog__header){
        border-bottom: 1px solid #f2f2f2;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    :deep(.el-dialog__close) {
        font-size: 24px!important;
    }
    :deep(.el-dialog) {
        border-radius: 8px;
    }
    :deep(.el-dialog__body){
        padding-top: 8px;
        padding-bottom: 8px;
    }
    :deep(.el-button+.el-button){
        margin-left: 12px;
        /*color: #ffffff;*/
    }
</style>
